import Action from 'ageas-react-component-action'
import { useEffect } from 'react'
import Switch from 'react-switch'
import { CONTEXT_DOCUMENT } from '../../../constants/contextDocument'
import { useUpdateQuotation } from '../../../hooks/api/updateQuotation/useUpdateQuotation'
import { useUpdateQuotationPayload } from '../../../hooks/api/updateQuotation/useUpdateQuotationPayload'

import { useDocumentStore } from '../../../Stores/useDocumentStore'
import { useQuotationMessageUpdateStore } from '../../../Stores/useQuotationMessageUpdateStore'
import { useQuotationStore } from '../../../Stores/useQuotationStore'
import { useGetQuotation } from '../../../hooks/api/getQuotation/useGetQuotation'
import { useGetQuotationPayload } from '../../../hooks/api/getQuotation/useGetQuotationPayload'
import { t } from '../../../i18n'
import { SwitchContainer } from '../styles'
import { AttachmentType, TableAttachment } from './TableAttachment'

type Props = {
  context: string
  disabled?: boolean
}

export const ToggleTableAttachment = ({ context, disabled }: Props) => {
  const { documents, resetDocuments, switchAttachment, setSwitchAttachment } =
    useDocumentStore()
  const { mutate: mutateGetQuotation } = useGetQuotation()
  const { resetQuotationMessage, quotationUpdate } =
    useQuotationMessageUpdateStore()
  const getQuotationPayload = useGetQuotationPayload()
  const { quotation } = useQuotationStore()

  const disabledSendUpdateQuotationButton =
    (quotationUpdate?.message?.messageText || '')?.length === 0 &&
    (quotationUpdate?.attachments || [])?.length === 0

  const handleSwitchChange = (nextChecked: boolean) => {
    setSwitchAttachment({ [context]: nextChecked })
  }
  const { updateQuotationPayload } = useUpdateQuotationPayload()
  const {
    mutate: mutateUpdateQuotation,
    isLoading: isLoadingUpdateQuotation,
    reset: resetUpdateQuotation,
    isSuccess,
  } = useUpdateQuotation()

  const getAttachmentData = () => {
    if (context === CONTEXT_DOCUMENT.QUOTATION_REQUEST) {
      return quotation?.attachments as AttachmentType[]
    }
    if (context === CONTEXT_DOCUMENT.QUOTATION_UPDATE) {
      return quotationUpdate?.attachments as AttachmentType[]
    }

    return (documents || [])?.map((file) => ({
      id: file.documentId,
      documentContent: file.file,
      documentName: file.fileDescription,
      documentType: file.docType,
    }))
  }

  useEffect(() => {
    if (isSuccess) {
      mutateGetQuotation(getQuotationPayload)
      setSwitchAttachment({ [context]: false })
      resetQuotationMessage()
      resetDocuments()
      resetUpdateQuotation()
    }
  }, [isSuccess])

  return (
    <SwitchContainer>
      <div className="switch-container">
        <label>
          <Switch
            disabled={disabled}
            onColor="#36d174"
            activeBoxShadow="none"
            height={28}
            width={48}
            handleDiameter={24}
            uncheckedIcon={false}
            checkedIcon={false}
            checked={switchAttachment[context] || false}
            onChange={handleSwitchChange}
          />
          <span className="text-label">
            {t('pages.step7.attachmentDocuments.title')}
          </span>
        </label>
      </div>
      {switchAttachment[context] && (
        <TableAttachment
          context={context}
          showUpdateQuotationButton={false}
          isLoadingUpdateQuotation={isLoadingUpdateQuotation}
          data={getAttachmentData() as never}
          disabled={disabled}
        />
      )}
      {context === CONTEXT_DOCUMENT.QUOTATION_UPDATE && (
        <div className="button-group">
          <Action
            id="buttonSendUpdateQuotation"
            label={t('pages.step5.sendUpdateQuotationButton')}
            type="button"
            disable={
              isLoadingUpdateQuotation ||
              disabledSendUpdateQuotationButton ||
              disabled
            }
            onValueChanged={() =>
              mutateUpdateQuotation(updateQuotationPayload(context))
            }
          />
        </div>
      )}
    </SwitchContainer>
  )
}
